import React from "react";
import ReactDOM from "react-dom/client";
import Gis from "./gis";
import "../../index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Gis />
  </React.StrictMode>,
);
